<template>
  <div>
    <h1>{{ $t('deviceTable') }}</h1>
    <div class="device-top" ref="midBox">
      <span class="item" style="margin-right: 14px">
        <span class="label">{{ this.$t('loop') }}:</span>
        <DropDown style="display: inline-block" :data="loopAllArr" :defaultVal="loopIndex" @select="handleLoop">
          <template v-slot:head>
            <el-button class="account-status">
              {{ loopSelectName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
          </template>
        </DropDown>
      </span>
      <span class="label">{{ this.$t('address') }}:</span><el-input style="width: 100px" maxlength="3" clearable v-model="searchInput" />
      <span class="item">
        <span class="label">{{ this.$t('type') }}:</span>
        <DropDown style="display: inline-block" :data="deviceTypeAllArr" :defaultVal="deviceTypeIndex" @select="handleSelect">
          <template v-slot:head>
            <el-button class="account-status">
              {{ selectName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
          </template>
        </DropDown>
      </span>
      <el-button class="blue-btn item" style="width: 40px" icon="el-icon-search" @click="search"></el-button>
      <span class="label" style="margin-left: 20px">{{ $t('total') }}:</span><span>{{ total }}</span>
      <!-- 这里暂时不翻译，因为不显示 -->
      <span style="float: right; font-size: 30px; position: relative; top: 2px;" class="right-icon">
        <el-popover
          placement="bottom"
          width="460"
          trigger="hover">
          <div class="table-title">{{ $t('sensitivityTips') }}</div>
          <div class="tip-box span-top"><span>{{ $t('profile') }}</span><span>{{ $t('sensitivitySmoke') }}</span><span>Sensitivity heat</span></div>
          <div class="tip-box" v-for="(item, index) in gridData" :key="index">
            <span>{{ item.profile }}</span><span>{{ item.smoke }}</span><span>{{ item.heat }}</span>
          </div>
          <!-- <i class="iconfont icon-jihuo7" slot="reference" style="font-size: 24px"></i> -->
        </el-popover>
        <el-tooltip :content="$t('import')" placement="bottom">
          <i class="iconfont icon-daochu" @click="changeUploadVisible"></i>
        </el-tooltip>
        <el-tooltip :content="$t('export')" placement="bottom">
          <i class="iconfont icon-daoru" @click="exportFile"></i>
        </el-tooltip>
        <el-button class="blue-btn save-btn" @click="saveAll">{{ $t('save') }}</el-button>
      </span>
    </div>
    <!-- <Table
      ref="deviceTable"
      v-if="height"
      :dataSource="dataSource"
      :columns="tableColumns"
      @selectionChange="handleSelectionChange"
      :height="height"
      :showNoMore="!canLoadMore && dataSource.length > 0"
      v-loadmore="loadMore"
    > -->
    <Table
      ref="deviceTable"
      v-if="height"
      :dataSource="dataSource"
      :columns="tableColumns"
      @selectionChange="handleSelectionChange"
      :height="height"
    >
      <!-- v-loadmore="getDeviceList(true)" -->
      <!-- <template #select>
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
      </template> -->
      <!-- <template #operation>
        <el-table-column
          width="110"
          :label="$t('operation')"
        >
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="$t('delete')" :hide-after="2000" placement="top">
              <i class="iconfont icon-shanchu pointer" @click="delRow(scope.row.id)"></i>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('save')" :hide-after="2000" placement="top">
              <i v-if="scope.row.isEdit" class="iconfont icon-baocun pointer" :class="{active: scope.row.id }" @click="saveRow(scope.row)"></i>
            </el-tooltip>
            <span v-if="scope.row.isEdit && !scope.row.isAdd" class="icon-baocun pointer" @click="cancelSaveRow(scope.$index)">取消</span>
            <i v-if="!scope.row.isEdit" class="iconfont icon-bianji pointer" @click="editRow(scope.row, scope.$index)"></i>
            <el-tooltip effect="dark" :content="$t('copy')" :hide-after="2000" placement="top">
              <i class="iconfont icon-fuzhi pointer" style="margin-left: 14px" @click="addRow(scope.row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </template> -->
    </Table>
    <Pagination
      v-if="dataSource.length > 0"
      :total="total"
      :pageSize="pageSize"
      :pageSizes="[20, 50, 100]"
      :currentPage="pageNumber"
      @change="pageSizeChange"
      style="margin: 10px 5% 0;"
    />
    <!-- <div style="text-align: center; margin-top: 20px" ref="addBtn">
      <i
        class="iconfont icon-- pointer add-btn"
        style="font-size: 40px"
        @click="addRow"
      ></i>
    </div> -->
    <uploadModal v-if="uploadVisible" :text="$t('importDeviceMsg')" @close="uploadVisible = !uploadVisible" @upload="upload" />
  </div>
</template>

<script>
import { getDeviceList, deleteDevice, addDevice, updateDevice,
          deviceTypeList, patchUpdateDevice } from '../../api/device'
import { getZoneList } from '../../api/zone'
import { importDevice, exportDevice } from '../../api/importAndExport'
import config from '../../common/config'
import uploadModal from '../../components/uploadModal.vue'
import router from '../../router'
import Cookies from 'js-cookie'
import { EventBus } from '../../store/eventBus'

export default {
  name: 'deviceTable',
  components: { uploadModal },
  data () {
    return {
      dataSource: [],
      dataSourceCopy: [],
      tableColumns: [{
        slotName: 'select'
      }, {
        prop: 'loopNo',
        label: this.$t('loop'),
        width: 50,
      }, {
        prop: 'address',
        label: this.$t('address'),
        width: 80
      }, {
        prop: 'devTypeCode',
        label: this.$t('type'),
        width: 160
      }, {
        prop: 'descr',
        label: this.$t('description'),
        width: 295
      }, {
        prop: 'zone',
        label: this.$t('zone'),
        width: 100
      }, {
        prop: 'groupNo',
        label: this.$t('group'),
        width: 100
      }, {
        prop: 'sensitivity_day',
        label: this.$t('sensitivityDuringProfileL1'),
        // width: 260
      }, {
        prop: 'sensitivity_night',
        label: this.$t('sensitivityDuringProfileL2'),
        // width: 260
      }, {
        prop: 'sensitivity_special',
        label: this.$t('sensitivityDuringProfileL3'),
        // width: 260
      }, {
        slotName: 'operation'
      }],
      sensitivityOptions: [],
      sensitivityOptions2: [{
        name: 1,
        value: 1
      }, {
        name: 2,
        value: 2
      }, {
        name: 3,
        value: 3
      }],
      // deviceTypeArr: config.deviceType,
      deviceTypeArr: [],
      deviceTypeAllArr: [],
      loopAllArr: [{
        name: this.$t('all'),
        code: ''
      }, {
        name: 1,
        code: 1
      }, {
        name: 2,
        code: 2
      }, {
        name: 3,
        code: 3
      }, {
        name: 4,
        code: 4
      }, {
        name: 5,
        code: 5
      }, {
        name: 6,
        code: 6
      }, {
        name: 7,
        code: 7
      }, {
        name: 8,
        code: 8
      }],
      uploadVisible: false,
      panelNo: this.$route.query.panelNo,
      projectId: this.$route.query.projectId,
      groupArr: [],
      zoneArr: [],
      canAdd: true,
      selectData: [],
      height: 0,
      pageNumber: 1,
      total: 0,
      pageSize: 20,
      addDataSource: [],
      canLoadMore: false,
      searchInput: '',
      deviceTypeIndex: 0,
      loopIndex: 0,
      selectName: this.$t('all'),
      selectValue: -1,
      loopSelectName: this.$t('all'),
      loopSelectValue: '',
      gridData: [{
        profile: '1',
        smoke: '1(high)',
        heat: '2(EN54-5 A2)'
      }, {
        profile: '2',
        smoke: '2(EN54-7)',
        heat: '2(EN54-5 A2)'
      }, {
        profile: '3',
        smoke: '2(EN54-7)',
        heat: '3(low)'
      }, {
        profile: '4',
        smoke: '2(EN54-7)',
        heat: '0(no heat alarm)'
      }, {
        profile: '5',
        smoke: '3(low)',
        heat: '2(EN54-5 A2)'
      }, {
        profile: '6',
        smoke: '0(no smoke alarm)',
        heat: '2(EN54-5 A2)'
      }],
      editData: [],
      editDataIndex: [],
      language: Cookies.get(config.language) || 'english',
      loop: ''
    }
  },
  mounted () {
    for (let i = 1; i <= 6; i++) {
      this.sensitivityOptions.push({
        name: i,
        value: i
      })
    }
    deviceTypeList({
      lan: this.language
    }).then(res => {
      this.deviceTypeArr = res.data
      this.deviceTypeAllArr = [{name: this.$t('all'), value: -1}, {code: 1, name: this.$t('notEmpty')}, ...res.data]
      this.getDeviceList()
    })
    // this.getZoneList()
    const height = window.innerHeight - this.$refs.midBox.getBoundingClientRect().top - 110
    this.height = height < 200 ? 200 : height
    EventBus.$on('checkSave', (cb) => {
      const data = this.handleData()
      if (data.length > 0) {
        this.checkCommit()
      } else {
        cb()
      }
    })
  },
  methods: {
    // getDeviceList (isLoad) {
    getDeviceList (pageObj = {pageNum: 1, pageSize: 20}) {
      if (this.searchInput && (isNaN(this.searchInput) || this.searchInput < 1 || this.searchInput > 400)) {
        this.$message.error(this.$t('outOfRange'))
        this.searchInput = ''
        return
      }
      // if (isLoad && this.total > 0 && this.total <= (this.pageNumber - 1) * this.pageSize) {
      //   this.canLoadMore = false
      //   return
      // }
      // this.canLoadMore = true
      this.pageNumber = pageObj.pageNum
      if (pageObj.pageNum === 1) {
        this.pageSize = pageObj.pageSize
      }
      // this.pageSize = pageObj.pageSize
      const params = {
        panelNo: this.panelNo,
        projectId: this.projectId,
        isPage: true,
        pageNumber: pageObj.pageNum,
        address: this.searchInput,
        pageSize: this.pageSize,
        loopNo: this.loopSelectValue
      }
      if (this.selectValue !== -1) {
        params.devTypeCode = this.selectValue
      }
      getDeviceList(params).then(res => {
        // this.dataSource = res.data
        // this.dataSourceCopy = JSON.parse(JSON.stringify(res.data))
        // this.pageNumber++
        const dataSource = res.data.map(n => {
          const item = {
            isEdit: true,
            id: n.id,
            loopNo: {
              value: n.loopNo
            },
            address: {
              value: n.address
            },
            devTypeCode: {
              value: n.devTypeCode,
              type: 'select',
              labelName: 'name',
              valueName: 'code',
              options: this.deviceTypeArr,
              change: (data, rowData, index) => {
                const result = this.deviceTypeArr.find(n => n.code == data.value )
                const deviceTypeName = result ? result.oldName : ''
                this.devTypeChange (deviceTypeName, rowData)
                this.addDataToArr(rowData, index)
              }
            },
            descr: {
              value: n.descr,
              type: 'input',
              maxlength: 32,
              change: (data, rowData, index) => {
                const value = data.value
                if (value.length > 32) {
                  this.$message.error(this.$t('tooLong'))
                  data.value = value.substr(0, 32)
                }
                this.addDataToArr(rowData, index)
              }
            },
            zone: {
              value: n.zone,
              type: 'input',
              // options: this.zoneArr,
              // filterable: true,
              disabled: false,
              change: (data, rowData, index) => {
                const value = +data.value
                if (value <= 0 || value > 400 || isNaN(value)) {
                  this.$message.error(this.$t('outOfRange'))
                  data.value = 1
                }
                this.addDataToArr(rowData, index)
              }
            },
            groupNo: {
              value: n.groupNo,
              type: 'input',
              // options: this.groupArr,
              // filterable: true,
              disabled: false,
              change: (data, rowData, index) => {
                const value = +data.value
                if (value <= 0 || value > 400 || isNaN(value)) {
                  this.$message.error(this.$t('outOfRange'))
                  data.value = 1
                }
                this.addDataToArr(rowData, index)
              }
            },
            sensitivity_day: {
              value: n.sensitivity_day,
              type: 'select',
              options: this.sensitivityOptions,
              width: 140,
              disabled: false,
              change: (data, rowData, index) => {
                this.addDataToArr(rowData, index)
              }
            },
            sensitivity_night: {
              value: n.sensitivity_night,
              type: 'select',
              width: 140,
              options: this.sensitivityOptions,
              disabled: false,
              change: (data, rowData, index) => {
                this.addDataToArr(rowData, index)
              }
            },
            sensitivity_special: {
              value: n.sensitivity_special,
              type: 'select',
              width: 140,
              options: this.sensitivityOptions,
              disabled: false,
              change: (data, rowData, index) => {
                this.addDataToArr(rowData, index)
              }
            }
          }
          const result = this.deviceTypeArr.find(m => m.code == n.devTypeCode )
          const deviceTypeName = result ? result.oldName : ''
          this.devTypeChange(deviceTypeName, item, n.groupNo, n.zone, n.sensitivity_day,
            n.sensitivity_night, n.sensitivity_special)
          return item
        })
        this.canAdd = true
        // this.dataSource = this.dataSource.concat(dataSource)
        this.dataSource = dataSource
        this.dataSourceCopy = config.deepClone(this.dataSource)
        this.total = res.total
        // 滚到第一条
        this.$nextTick(() => {
          this.$refs.deviceTable.$el.querySelector('.el-table__body-wrapper').scrollTop = 0
        })
        // if ((this.total > 0 && this.total <= (this.pageNumber - 1) * this.pageSize) || !res.total) {
        //   this.canLoadMore = false
        // }
      })
    },
    search () {
      this.$refs.deviceTable.$el.querySelector('.el-table__body-wrapper').scrollTop = 0
      const data = this.handleData()
      if (data.length > 0) {
        this.checkCommit()
        return
      } 
      if (this.searchInput && (isNaN(this.searchInput) || this.searchInput < 1 || this.searchInput > 400)) {
        this.$message.error(this.$t('outOfRange'))
        this.searchInput = ''
        return
      }
      this.pageNumber = 1
      this.dataSource = []
      this.getDeviceList()
    },
    addRow (obj) {
      const isCopy = obj.id
      const data = {
        isEdit: true,
        isAdd: true,
        loopNo: {
          value: isCopy ? obj.loopNo.value : 1,
          type: 'select',
          options: [{
            value: 1,
            name: 1
          }, {
            value: 2,
            name: 2
          }]
        },
        address: {
          value: isCopy ? obj.address.value : 1,
          type: 'input',
          change: (data) => {
            const value = +data.value
            if (value < 1 || value > 200 || isNaN(value)) {
              this.$message.error(this.$t('outOfRange'))
              data.value = 1
            }
          }
        },
        devTypeCode: {
          value: isCopy ? obj.devTypeCode.value : this.deviceTypeArr[0].code,
          type: 'select',
          labelName: 'name',
          valueName: 'code',
          options: this.deviceTypeArr,
          change: (data, rowData) => {
            const deviceTypeName = this.deviceTypeArr.find(n => n.code == data.value ).oldName
            this.devTypeChange (deviceTypeName, rowData)
          }
        },
        descr: {
          value: isCopy ? obj.descr.value : '',
          type: 'input',
          maxlength: 32,
          change: (data, rowData) => {
            const value = data.value
            if (value.length > 32) {
              this.$message.error(this.$t('tooLong'))
              data.value = value.substr(0, 32)
            }
          }
        },
        zone: {
          value: isCopy ? obj.zone.value : this.zoneArr[0].value,
          type: 'select',
          options: this.zoneArr,
          filterable: true,
          disabled: false
        },
        groupNo: {
          value: isCopy ? obj.groupNo.value : '',
          type: 'select',
          options: this.groupArr,
          filterable: true,
          disabled: true
        },
        sensitivity_day: {
          value: isCopy ? obj.sensitivity_day.value : '',
          type: 'select',
          options: []
        },
        sensitivity_night: {
          value: isCopy ? obj.sensitivity_night.value : '',
          type: 'select',
          options: []
        },
        sensitivity_special: {
          value: isCopy ? obj.sensitivity_special.value : '',
          type: 'select',
          options: []
        }
      }
      if (!this.canAdd) {
        this.$message.error(this.$t('unSavedWarning'))
        return
      }
      this.addDataSource.push(data)
      const elm = document.getElementsByClassName('el-table__body-wrapper')[0]
      setTimeout(() => {
        elm.scrollTop = elm.scrollHeight
      }, 100)
      this.canAdd = false
      if (isCopy) {
        this.$refs['addBtn'].scrollIntoView()
        this.$message.success(this.$t('copySuccess'))
      }
    },
    delRow (id) {
      this.$msgbox({
        title: this.$t('prompt'),
        message: this.$t('sureDelete'),
        showCancelButton: true,
        confirmButtonText: this.$t('sure'),
        cancelButtonText: this.$t('cancel'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            // instance.confirmButtonText = '执行中...'
            if (id) {
              const params = {
                id: id
              }
              deleteDevice(params).then(res => {
                this.$message.success(this.$t('deleteSuccess'))
                instance.confirmButtonLoading = false
                this.dataSource = []
                this.pageNumber = 1
                this.total = 0
                this.dataSource = []
                this.getDeviceList()
                done()
              }).catch(() => {
                instance.confirmButtonLoading = false
              })
            } else {
              this.$message.success(this.$t('deleteSuccess'))
              instance.confirmButtonLoading = false
              this.addDataSource.pop()
              this.canAdd = true
              done()
            }
          } else {
            done()
          }
        }
      }).then(action => {
      })
    },
    saveRow (data) {
      const params = {
        panelNo: this.panelNo,
        projectId: this.projectId,
        loopNo: data.loopNo.value,
        address: data.address.value,
        descr: data.descr.value,
        zone: data.zone.value,
        sensitivity_day: data.sensitivity_day.value,
        sensitivity_night: data.sensitivity_night.value,
        sensitivity_special: data.sensitivity_special.value,
        devTypeCode: data.devTypeCode.value,
        groupNo: data.groupNo.value
      }
      // const deviceTypeName = this.deviceTypeArr.find(n => n.code == params.devTypeCode ).name
      // if (deviceTypeName === 'MCP' || deviceTypeName === 'HD' || deviceTypeName === 'OHD'
      //   || deviceTypeName === '1IM' || deviceTypeName ===  'OD' ) {
      //   if (params.groupNo) {
      //     this.$message.error('Error')
      //     return
      //   }
      // } else {
      //   if (params.zone) {
      //     this.$message.error('Error')
      //     return
      //   }
      // }

      if (data.isAdd) {
        addDevice(params).then(res => {
          this.$message.success(this.$t('addSuccess'))
          this.dataSource = []
          this.pageNumber = 1
          this.total = 0
          this.addDataSource = []
          this.getDeviceList()
        })
      } else {
        params.id = data.id
        updateDevice(params).then(res => {
          this.$message.success(this.$t('saveSuccess'))
          this.dataSource = []
          this.pageNumber = 1
          this.total = 0
          this.addDataSource = []
          this.getDeviceList()
        })
      }
    },
    editRow (data, index) {
      const item = {
        isEdit: true,
        id: data.id,
        loopNo: {
          value: data.loopNo,
          type: 'select',
          options: [{
            value: 1,
            name: 1
          }, {
            value: 2,
            name: 2
          }]
        },
        address: {
          value: data.address,
          type: 'input'
        },
        devTypeCode: {
          value: data.devTypeCode,
          type: 'select',
          options: this.deviceTypeArr
        },
        descr: {
          value: data.descr,
          type: 'input'
        },
        zone: {
          value: data.zone,
          type: 'input'
        },
        groupNo: {
          value: data.groupNo,
          type: 'input'
        },
        sensitivity_day: {
          value: data.sensitivity_day,
          type: 'select',
          options: this.sensitivityOptions
        },
        sensitivity_night: {
          value: data.sensitivity_night,
          type: 'select',
          options: this.sensitivityOptions
        },
        sensitivity_special: {
          value: data.sensitivity_special,
          type: 'select',
          options: this.sensitivityOptions
        }
      }
      this.$set(this.dataSource, index ,item)
    },
    cancelSaveRow (index) {
      this.$set(this.dataSource, index, this.dataSourceCopy[index])
    },
    upload (file) {
      const params = new FormData()
      params.append('file', file)
      params.append('userId', Cookies.get(config.userId))
      params.append('panelNo', this.panelNo)
      params.append('projectId', this.projectId)
      params.append('loadingText', this.$t('globalLoadingText'))
      params.append('lan', Cookies.get(config.language))
      if (file) {
        importDevice(params).then(res => {
          this.pageNumber = 1
          this.dataSource = []
          this.getDeviceList()
          this.$message.success('importFilesuccess')
          this.uploadVisible = false
        })
      }
    },
    exportFile () {
      const params = {
        projectId: this.projectId,
        userId: Cookies.get(config.userId),
        panelNo: this.panelNo,
        address: this.searchInput,
        devTypeCode: this.selectValue !== -1 ? this.selectValue : '',
        lan: this.language
      }
     
      exportDevice(params).then(res => {
        this.$message.success(this.$t('deviceExportSuccess'))
      })
    },
    getZoneList () {
      const params = {
        panelNo: this.panelNo,
        projectId: this.projectId,
        zone: this.searchInput
      }
     
      getZoneList(params).then(res => {
        if (res.data.length >= 0) {
          res.data.map(n => {
            if (n.type === 0) {
              this.zoneArr.push({
                name: n.zone,
                value: n.zone
              })
            } else if (n.type === 1) {
              this.groupArr.push({
                name: n.zone,
                value: n.zone
              })
            }
          })
        }
      })
    },
    devTypeChange (deviceTypeName, rowData, groupNo, zone, l1, l2, l3) {
      if (deviceTypeName === 'MCP' || deviceTypeName === 'HD' || deviceTypeName === 'OHD'
        || deviceTypeName === '1IM' || deviceTypeName ===  'OD' || deviceTypeName ==='INF' || deviceTypeName ==='ZMM' || deviceTypeName ==='ZMD'|| deviceTypeName ==='ZMA') {
        rowData.groupNo.disabled = true
        rowData.groupNo.value = ''
        rowData.zone.value = zone || 1
        rowData.zone.disabled = false
        if (deviceTypeName === 'HD' || deviceTypeName === 'OD') {
          rowData.sensitivity_day.options = this.sensitivityOptions2
          rowData.sensitivity_day.value = l1 || 2
          rowData.sensitivity_day.disabled = false
          rowData.sensitivity_night.options = this.sensitivityOptions2
          rowData.sensitivity_night.value = l2 || 2
          rowData.sensitivity_night.disabled = false
          rowData.sensitivity_special.options = this.sensitivityOptions2
          rowData.sensitivity_special.value = l3 || 2
          rowData.sensitivity_special.disabled = false
        } else if (deviceTypeName === 'OHD' ) {
          rowData.sensitivity_day.options = this.sensitivityOptions
          rowData.sensitivity_day.value = l1 || 2
          rowData.sensitivity_day.disabled = false
          rowData.sensitivity_night.options = this.sensitivityOptions
          rowData.sensitivity_night.value = l2 || 2
          rowData.sensitivity_night.disabled = false
          rowData.sensitivity_special.options = this.sensitivityOptions
          rowData.sensitivity_special.value = l3 || 2
          rowData.sensitivity_special.disabled = false
        } else {
          rowData.sensitivity_day.options = []
          rowData.sensitivity_day.value = ''
          rowData.sensitivity_day.disabled = true
          rowData.sensitivity_night.options = []
          rowData.sensitivity_night.value = ''
          rowData.sensitivity_night.disabled = true
          rowData.sensitivity_special.options = []
          rowData.sensitivity_special.value = ''
          rowData.sensitivity_special.disabled = true
        }
      } else {
        rowData.groupNo.disabled = false
        rowData.groupNo.value = groupNo || ''
        // SND特殊判断 设置goup为3 20210112取消
        if (deviceTypeName === 'SND') {
          rowData.groupNo.value = groupNo || 1
        } else if (deviceTypeName === 'IOM' || deviceTypeName === 'OM') {
          rowData.groupNo.value = groupNo || 3
        }
        rowData.zone.value = ''
        rowData.zone.disabled = true
        rowData.sensitivity_day.options = []
        rowData.sensitivity_day.value = ''
        rowData.sensitivity_day.disabled = true
        rowData.sensitivity_night.options = []
        rowData.sensitivity_night.value = ''
        rowData.sensitivity_night.disabled = true
        rowData.sensitivity_special.options = []
        rowData.sensitivity_special.value = ''
        rowData.sensitivity_special.disabled = true
        // if (deviceTypeName === this.$t('empty')) {
        if (deviceTypeName === 'EMPTY') {
          rowData.groupNo.disabled = true
          rowData.groupNo.value = ''
        }
      }
    },
    handleSelectionChange (val) {
      this.selectData = val
    },
    saveAll (cb) {
      // if (this.selectData.length === 0) {
      //   this.$message.error(this.$t('pleaseChooseData'))
      //   return
      // }
      
      const data = this.handleData()
      if (data.length === 0) {
        this.$message.error(this.$t('notModified'))
        return
      }

      let isAdd = false
      const arr = this.editData.map(n => {
        const item = {
          panelNo: this.panelNo,
          projectId: this.projectId,
          loopNo: n.loopNo.value,
          address: n.address.value,
          descr: n.descr.value,
          zone: n.zone.value,
          sensitivity_day: n.sensitivity_day.value,
          sensitivity_night: n.sensitivity_night.value,
          sensitivity_special: n.sensitivity_special.value,
          devTypeCode: n.devTypeCode.value,
          groupNo: n.groupNo.value
        }
        if (n.id) {
          item.id = n.id
        } else {
          isAdd = true
        }
        return item
      })
      patchUpdateDevice(arr).then(res => {
        this.$message.success(this.$t('saveSuccess'))
        if (isAdd) {
          this.addDataSource = []
        }
        // this.getDeviceList()
        this.total = 0
        this.dataSource = []
        this.getDeviceList({pageNum: this.pageNumber, pageSize: this.pageSize})
        this.editDataIndex = []
        this.editData = []
        if (typeof cb === 'function') {
          cb()
        }
      })
    },
    // 取消已编辑内容
    cancelEdit (done) {
      this.editDataIndex.map(n => {
        this.$set(this.dataSource, n, config.deepClone(this.dataSourceCopy[n]))
      })
      this.editDataIndex = []
      this.editData = []
      done()
    },
    // 将修改的值存起来，判断是否重复
    addDataToArr (data, index) {
      const _index = this.editDataIndex.indexOf(index)
      if ( _index === -1) {
        this.editDataIndex.push(index)
        this.editData.push(data)
      } else {
        this.editData[_index] = data
      }
    },
    handleSelect (data) {
      this.selectName = data.name
      this.selectValue = data.code
    },
    handleLoop (data) {
      this.loopSelectName = data.name
      this.loopSelectValue = data.code
    },
    // loadMore () {
    //   this.getDeviceList(true)
    // },
    handleData () {
      const keys = ['descr', 'zone', 'groupNo', 'sensitivity_day', 'sensitivity_night', 'sensitivity_special', 'devTypeCode']
      const data = []
      this.editDataIndex.map((n, i) => {
        const newData = this.editData[i]
        const oldData = this.dataSourceCopy[n]
        var notSave = true
        for (let i = 0, len = keys.length; i < len; i++) {
          const oldValue = oldData[keys[i]].value !== 0 ? oldData[keys[i]].value || '' : 0
          const newValue = newData[keys[i]].value !== 0 ? newData[keys[i]].value || '' : 0
          if (newValue != oldValue) {
            notSave = false
          }
        }
        if (!notSave) {
          data.push(newData)
        }
      })
      return data
    },
    checkCommit () {
      this.$msgbox({
        title: this.$t('prompt'),
        message: this.$t('unsavedRemind'),
        showClose: false,
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: this.$t('sure'),
        cancelButtonText: this.$t('cancel'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.saveAll(done)
          } else {
            this.cancelEdit(done)
            // done()
          }
        }
      }).then(action => {
      })
    },
    changeUploadVisible () {
      const data = this.handleData()
      if (data.length > 0) {
        this.checkCommit()
      } else {
        this.uploadVisible = !this.uploadVisible
      }
    },
    pageSizeChange (val) {
      const data = this.handleData()
      if (data.length > 0) {
        this.$msgbox({
          title: this.$t('prompt'),
          message: this.$t('unsavedRemind'),
          showClose: false,
          closeOnClickModal: false,
          showCancelButton: true,
          confirmButtonText: this.$t('sure'),
          cancelButtonText: this.$t('cancel'),
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              this.saveAll(done)
            } else {
              // this.cancelEdit(done)
              this.editDataIndex = []
              this.editData = []
              this.getDeviceList(val)
              done()
            }
          }
        }).then(action => {
        })
      } else {
        this.getDeviceList(val)
      }
      // this.getZoneList()
    }
  },
  beforeRouteLeave (to, from, next) {
    // 在token失效时,会跳转到/，此时不必拦截
    if (to.path !== '/') {
      const data = this.handleData()
      if (data.length > 0) {
        next(false)
        this.checkCommit()
      } else {
        next()
      }
    } else {
      next()
    }
  },
  beforeDestroy () {
    EventBus.$off('checkSave')
  }
}
</script>

<style lang="less" scope>
.device-top {
  // text-align: right;
  margin: 10px 0;
  .right-icon i {
    font-size: 30px;
    margin: 0 10px;
    cursor: pointer;
  }
  .save-btn {
    position: relative;
    top: -8px;
    margin-left: 14px;
  }
  .el-select {
    input {
      border: none;
      color: @color-primary!important;;
      background-color: transparent!important;
      cursor: text!important;
    }
    .el-input__suffix {
      display: none;
    }
  }
}
.icon-baocun, .icon-bianji {
  margin-left: 15px;
}
.active {
  color: @color-blue;
}
.add-btn {
  color: @color-blue;
}
h1 {
  font-size: 24px;
  font-weight: 400;
}
.item {
  margin-left: 20px;
}
.label {
  padding-right: 10px;
}
.account-status {
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 40px;
  color: @color-primary;
  border: 1px solid @color-primary;
  background-color: #F3F5F9;
  .f-s-16();
  i {
    font-size: 18px;
  }
}
.table-title {
  text-align: center;
  font-size: 18px;
  font-family: baseFont;
  font-weight: normal;
  color: #c1d9ee;
  margin-top: 10px;
}
.tip-box {
  margin-left: 20px;
  span {
    display: inline-block;
    color: #fff;
    padding: 10px 0;
    &:nth-of-type(1) {
      width: 80px;
    }
    &:nth-of-type(2) {
      width: 180px;
    }
    &:nth-of-type(3) {
      width: 180px;
    }
  }
}
.span-top span {
  font-size: 18px;
  color: #c1d9ee;
}
</style>

<style lang="less">
.el-popover {
  background: #83909B;
}
</style>